import { render, staticRenderFns } from "./LiquidacionFinal.vue?vue&type=template&id=923ed198&"
import script from "./LiquidacionFinal.vue?vue&type=script&lang=js&"
export * from "./LiquidacionFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports